/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersBudgetDto } from '../../models/users-budget-dto';

export interface GetMonthlyBudget$Params {
  year: number;
  month: number;
}

export function getMonthlyBudget(http: HttpClient, rootUrl: string, params: GetMonthlyBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UsersBudgetDto>>> {
  const rb = new RequestBuilder(rootUrl, getMonthlyBudget.PATH, 'get');
  if (params) {
    rb.path('year', params.year, {});
    rb.path('month', params.month, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UsersBudgetDto>>;
    })
  );
}

getMonthlyBudget.PATH = '/budget-management/{year}/{month}';
